"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueCommentsApi = void 0;
var _types = require("../types");
var _fetchHelpers = require("../util/fetchHelpers");
var _endpointHelpers = require("../util/endpointHelpers");
var _urlExtractors = require("../util/urlExtractors");
const IssueCommentsApi = exports.IssueCommentsApi = (0, _endpointHelpers.createEndpointSdk)(_ref => {
  let {
    api
  } = _ref;
  return {
    getAll: function (issueId) {
      let {
        limit = 5,
        offset = 0,
        sortBy = {
          attribute: _types.IssueSortingField.CreatedAt,
          direction: _types.IssueSortingDirection.Desc
        }
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return api.getAll("issues/".concat(issueId, "/comments").concat((0, _fetchHelpers.getSearchQueryString)({
        limit,
        offset,
        sortBy
      })));
    },
    get: (issueId, id) => api.get("issues/".concat(issueId, "/comments/").concat(id)),
    create: (issueId, body) => api.create("issues/".concat(issueId, "/comments"), {
      body
    })
  };
}, {
  // invalidated also by Issues api
  invalidateByQueryKeys: url => [["issues", (0, _urlExtractors.extractIssueId)(url), "comments"]]
});
//# sourceMappingURL=IssueCommentsApi.js.map